export const enTranslations = {
    email: "E-mail",
    password: "Password",
    write_your_email: "Write your E-mail",
    write_your_password: "Write your password",
    login: "Login",
    user_login_bad_credentials: "The user information you provided does not exist or the credentials used are not correct.",
    go_home: "Go to home page",
    profile: "Profile",
    edit_profile: "Edit profile",
    exit: "Logout",
    menu: "Menu",
    administration: "Administration",
    specialities: "Specialities",
    modalities: "Modalities",
    clubs: "Clubs",
    teams: "Teams",
    team: "Team",
    seasons: "Seasons",
    "Name": "Name",
    changed_at: "Last updated",
    "Write to search": "Write to search",
    search: "Search",
    new_speciality: "New speciality",
    "Delete": "Delete",
    delete_speciality: "Delete speciality",
    delete_speciality_message: "Speciality <strong>{{speciality_name}} ({{speciality_code}})</strong> and all related data will be deleted. This action cannot be undone. Do you really want to delete it permanently?",
    "Save": "Save",
    "Close": "Close",
    actions: "actions",
    description: "Description",
    code: "Code",
    edit_speciality: "Edit speciality",
    icon_upload_message: "Optionally upload an image",
    single_image_warning: "Only un file of type image can be uploaded. Delete the current image to upload a different one.",
    new_modality: "New modality",
    speciality: "Speciality",
    gender: "Gender",
    select_gender: "- Select gender -",
    man: "Man",
    woman: "Woman",
    "Men": "Men",
    "Women": "Women",
    "Mixt": "Mixt",
    distance: "Distance",
    boat: "Boat",
    edit_modality: "Edit modality",
    delete_modality_message: "Modality <strong>{{speciality_name}}</strong> and all related data will be deleted. This action cannot be undone. Do you really want to delete it permanently?",
    new_club: "New club",
    edit_club: "Edit club",
    delete_club: "Delete club",
    document_id: "ID",
    date_foundation: "Foundation date",
    region: "Region",
    city: "City",
    website: "Website",
    address: "Address",
    phone: "Phone",
    registry_num: "Registry number",
    select_region: "- Select region -",
    logo: "Logo",
    delete_club_message: "Club <strong>{{club_name}}</strong> and all related data will be deleted. This action cannot be undone. Do you really want to delete it permanently?",
    new_season: "New season",
    "Start date": "Start date",
    "End date": "End date",
    edit_season: "Edit season",
    "Delete season": "Delete season",
    delete_season_message: "Season <strong>{{season_name}}</strong> and all related data will be deleted. This action cannot be undone. Do you really want to delete it permanently?",
    categories: "Categories",
    new_category: "New category",
    edit_category: "Edit category",
    age_start: "Age start",
    age_end: "Age end",
    start_age_warning: "Set a valid age.",
    delete_category: "Delete category",
    delete_category_message: "Category <strong>{{category_name}}</strong> and all related data will be deleted. This action cannot be undone. Do you really want to delete it permanently?",
    new_team: "New team",
    club: "Club",
    select_club: "- Select club",
    modality: "Modality",
    select_modality: "- Select modality -",
    category: "Category",
    select_category: "- Select category -",
    edit_team: "Edit team",
    delete_team: "Delete team",
    delete_team_message: "Team <strong>{{team_name}}</strong> and all related data will be deleted. This action cannot be undone. Do you really want to delete it permanently?",
    management: "Management",
    users: "Users",
    new_user: "New user",
    first_name: "First name",
    last_name: "Last name",
    birthdate: "Birthdate",
    role: "Role",
    "Administrator": "Administrador",
    "Manager": "Manager",
    "Coach": "Coach",
    "Athlete": "Athlete",
    edit_user: "Edit user",
    delete_user: "Delete user",
    delete_user_message: "User <strong>{{user_name}} ({{user_email}})</strong> and all related data will be deleted. This action cannot be undone. Do you really want to delete it permanently?",
    my_space: "My space",
    athletes: "Athletes",
    "Reports": "Reports",
    coach: "Coach",
    training_templates: "Training templeates",
    training_sessions: "Training sessions",
    athlete: "Athlete",
    disable_user: "Disable user",
    disable_user_message: "User <strong>{{user_name}} ({{user_email}})</strong> will be disabled. That means that he/she will no longer be able to access the platform until enabled again. ¿Are you sure you want to diable him/her?",
    disable: "Disable",
    user_status_switch_label: "User is enabled?",
    disabled: "Disabled",
    new_athlete: "New athlete",
    birth_city: "City of birth",
    birth_region: "Region of birth",
    birth_country: "Country of birth",
    country: "Country",
    athlete_status_switch_label:  "¿Is athlete active?",
    birth_place: "Place of birth",
    residence_place: "Personal address",
    select_country: "- Select country -",
    avatar_upload_message: "Optionally upload a photo of the athlete",
    years: "Years",
    edit_athlete: "Edit athlete",
    team_athletes: "Team athletes",
    "Remove from team": "Remove from team",
    "Add to team": "Add to team",
    "Adding... ({{done}} of {{total}})": "Adding... ({{done}} of {{total}})",
    "Removing... ({{done}} of {{total}})": "Removing... ({{done}} of {{total}})",
    "Back": "Back",
    "No athletes available": "No athletes available",
    "Previous year": "Previous year",
    "Next year": "Next year",
    "Activity type": "Activity type",
    "All types": "All",
    "Total distance": "Total distance",
    "Max Heart Rate": "Max Heart Rate",
    "Aerobic efficiency": "Aerobic efficiency",
    "Aerobic efficiency formula": "Average speed ÷ average heart rate × 100. Higher = faster at the same heart rate (better fitness).",
    "Kayak": "Kayak",
    "Whitewater kayak": "Whitewater kayak",
    "Canoe": "Canoe",
    "Paddle surf": "Paddle surf",
    season: "Season",
    select_season: "- Select season -",
    select_athlete: "- Select athlete -",
    dorsal: "Dorsal",
    position: "Position",
    athlete_measurements: "Athlete measurements",
    measurement_date: "Measurement date",
    weight_label: "Weight (gr)",
    height_label: "Height (cm)",
    bmi_label: "IMC (kg/m²)",
    fm_label: "Fat (kg/m²)",
    bm_label: "Mass (kg/m²)",
    "Table view": "Table view",
    "Card view": "Card view",
    "Select all": "Select all",
    "Deselect all": "Deselect all",
    "Add performance": "Add performance",
    "Add performance for": "Add performance for",
    "Performance data added successfully for": "Performance data added successfully for",
    "Some performance data could not be added. Please try again.": "Some performance data could not be added. Please try again.",
    "Error adding performance data. Please try again.": "Error adding performance data. Please try again.",
    "Saving...": "Saving...",
    "Age": "Age",
    "Avatar": "Avatar",
    "Add performance data": "Add performance data",
    "Save data": "Save data",
    "No performance data to save": "No performance data to save",
    "Performance data saved successfully": "Performance data saved successfully",
    "Cancel": "Cancel",
    "Accept": "Accept",
    "Settings": "Settings",
    "Select setting to configure": "Select setting to configure",
    "- Select -": "- Select -",
    "Performance KPIs": "Performance KPIs",
    "Performance KPIs Configuration": "Performance KPIs Configuration",
    "Define labels and units for each performance KPI": "Define labels and units for each performance KPI",
    "no_active_kpis_configured": "No active KPIs configured",
    "No performance data available": "No performance data available",
    "Select a KPI to display": "Select a KPI to display",
    "Select KPI": "Select KPI",
    "Year": "Year",
    "KPI": "KPI",
    "Label": "Label",
    "Unit": "Unit",
    "e.g., Speed": "e.g., Speed",
    "e.g., km/h": "e.g., km/h",
    "e.g., Distance": "e.g., Distance",
    "e.g., meters": "e.g., meters",
    "e.g., Power": "e.g., Power",
    "e.g., watts": "e.g., watts",
    "e.g., Heart Rate": "e.g., Heart Rate",
    "e.g., bpm": "e.g., bpm",
    "Settings saved successfully": "Settings saved successfully",
    "Error saving settings. Please try again.": "Error saving settings. Please try again.",
    "Loading...": "Loading...",
    "Loading settings...": "Loading settings...",
    "Performance Evolution": "Performance Evolution",
    "Value": "Value",
    staff: "Staff",
    new_staff: "New staff member",
    edit_staff: "Edit staff member",
    staff_status_switch_label:  "Staff member is active?",
    team_staff: "Staff members",
    select_staff: "- Select staff -",
    "User": "User",
    notifications: "Notifications",
    wearables: "Wearables",
    select_team: "- Select team -",
    videos: "Videos",
    video_upload_message: "Upload video",
    video_mandatory_alert: "You must upload one video",
    edit_video: "Edit video",
    delete_video: "Delete video",
    delete_video_message: "The video <strong>{{video_name}}</strong> and all data dependent on it will be deleted. This action cannot be undone. Are you sure you want to permanently delete it?",
    training_session_tpls: "Training session templates",
    new_training_session_tpl: "New training session template",
    edit_training_session_tpl: "Edit training session template",
    new_training_session: "New training session",
    edit_training_session: "Edit training session",
    goals: "Goals",
    phases: "Exercise groups",
    delete_training_session_tpl: "Delete training session template",
    delete_training_session_tpl_message: "The training session template <strong>{{training_session_tpl_name}}</strong> and all data dependent on it will be deleted. This action cannot be undone. Are you sure you want to permanently delete it?",
    new_training_session_phase_tpl: "New group of exercises",
    delete_training_session: "Delete training session",
    delete_training_session_message: "The training session <strong>{{training_session_name}}</strong> and all data dependent on it will be deleted. This action cannot be undone. Are you sure you want to permanently delete it?",
    new_training_session_phase: "New group of exercises",
    recipients_training: "Athletes who will do it",
    new_phase: "New group of exercises",
    training_session_no_recipients: "There are no athletes assigned to this training session.",
    add_athletes: "Add athletes",
    select_option: "- Select an option -",
    add: "Add",
    reference_already_assigned: "This assignment already exists",
    no_exercises_in_phase: "No exercises have been defined for this group",
    edit_training_session_phase_tpl: "Edit exercise group",
    delete_training_session_phase_tpl: "Delete exercise group",
    delete_training_session_phase_tpl_message: "The <strong>{{training_session_tpl_phase_name}}</strong> exercise group and all data dependent on it will be deleted. This action cannot be undone. Are you sure you want to permanently delete it?",
    edit_training_session_phase: "Edit exercise group",
    delete_training_session_phase: "Delete exercise group",
    delete_training_session_phase_message: "The <strong>{{training_session_phase_name}}</strong> exercise group and all data dependent on it will be deleted. This action cannot be undone. Are you sure you want to permanently delete it?",
    add_exercise: "Add exercise",
    new_training_session_exercise_tpl: "New exercise",
    delete_training_session_exercise_tpl: "Eliminar ejercicio",
    delete_training_session_exercise_tpl_message: "The <strong>{{training_session_tpl_exercise_name}}</strong> exercise and all data dependent on it will be deleted. This action cannot be undone. Are you sure you want to permanently delete it?",
    edit_training_session_exercise_tpl: "Edit exercise",
    new_training_session_exercise: "New exercise",
    delete_training_session_exercise: "Delete exercise",
    delete_training_session_exercise_message: "The <strong>{{training_session_exercise_name}}</strong> exercise and all data dependent on it will be deleted. This action cannot be undone. Are you sure you want to permanently delete it?",
    edit_training_session_exercise: "Edit exercise",
    no_videos_in_phase: "No videos have been associated with this group.",
    add_videos: "Añadir videos",
    video_selector: "Video selector",
    no_videos_in_excercise: "No se han asociado videos a este ejercicio",
    clone: "Clone",
    exercises: "Exercises",
    no_phases_message: "No defined exercise group",
    one_phase: "1 group of exercises",
    multiple_phases: "exercise groups",
    no_exercises_message: "No defined exercise",
    one_exercise: "1 exercise",
    multiple_exercises: "exercises",
    zero_exercises: "0 exercises",
    date_part: "Date",
    time_part: "Time",
    date_time: "Date and time",
    message_template_source: "How do you want to start designing your training session?",
    from_scratch: "From scratch",
    from_template: "Using a template",
    select_template: "- Select template -",
    no_date_planned: "Unplanned activity",
    trainings: "Trainings",
    trainings_maintenance: "Trainings Maintenance",
    search_by_type_description: "Search by type or description",
    "Content Distribution": "Content Distribution",
    "Number of sessions": "Number of sessions",
    "Total sessions": "Total sessions",
    "Enter the total number of training sessions": "Enter the total number of training sessions",
    "Edit Content": "Edit Content",
    "Enter a numeric value or descriptive text": "Enter a numeric value or descriptive text",
    "Additional notes or comments": "Additional notes or comments",
    new_training: "New Training",
    edit_training: "Edit Training",
    delete_training: "Delete Training",
    add_section: "Add Section",
    section_name: "Section Name",
    section_color: "Section Color",
    edit_section: "Edit Section",
    delete_section: "Delete Section",
    delete_section_confirm: "Are you sure you want to delete this section? Trainings will not be deleted.",
    "Loading trainings...": "Loading trainings...",
    type: "Type",
    select_type: "- Select type -",
    aerobic: "Aerobic",
    anaerobic: "Anaerobic",
    strength: "Strength",
    technique: "Technique",
    tactical: "Tactical",
    load: "Load",
    comments: "Comments",
    values: "Values",
    km: "KM",
    th: "TH",
    code_extra: "Code",
    note: "Note",
    "Are you sure you want to delete this training?": "Are you sure you want to delete this training?",
    "Training cannot be deleted": "Training cannot be deleted",
    "Error creating training": "Error creating training",
    "Error updating training": "Error updating training",
    "Error deleting training": "Error deleting training",
    "Please fill in all required fields": "Please fill in all required fields",
    competitions: "Competitions",
    new_competition: "New competition",
    date_description: "Description of the date",
    venue_name: "Name of the venue",
    venue_link: "Link to the venue",
    documents_upload_message: "You can optionally upload documents",
    Documents: "Documents",
    delete_competition: "Delete competition",
    delete_competition_message: "The <strong>{{competition_name}}</strong> competition and all data dependent on it will be deleted. This action cannot be undone. Are you sure you want to permanently delete it?",
    edit_competition: "Edit competition",
    passed_competitions: "Past competitions",
    upcoming_events: "Upcoming events",
    "Races": "Races",
    "Race list": "Race list",
    "Add race": "Add race",
    "No races scheduled for this week": "No races scheduled for this week",
    "Edit race": "Edit race",
    "New race": "New race",
    "e.g., National Championship": "e.g., National Championship",
    "Additional details about the race": "Additional details about the race",
    "Please enter a title for the race": "Please enter a title for the race",
    "Error saving race. Please try again.": "Error saving race. Please try again.",
    "Are you sure you want to delete this race?": "Are you sure you want to delete this race?",
    "Error deleting race. Please try again.": "Error deleting race. Please try again.",
    "from": "from",
    "to": "to",
    connection_expired: "Session expired. Authenticate again to access.",
    welcome: "Welcome",
    forgot_password_question: "Forgot your password?",
    reset_password: "Reset password",
    rankings: "Rankings",
    color: "Color",
    management_2: "Manage",
    birth: "Birth",
    contact_info: "Contact info",
    weight: "Weight",
    "Body Mass Index": "Body Mass Index",
    "Body Mass": "Body Mass",
    "Fat mass": "Fat mass",
    "Athletes ranking": "Athletes ranking",
    "Teams ranking": "Teams ranking",
    "Statistics": "Statistics",
    "Athletes statistics": "Athletes statistics",
    "Teams statistics": "Teams statistics",
    "Performance": "Performance",
    delete_ats_message: "The athlete assignment to the team and season will be deleted. This action cannot be undone. Are you sure you want to permanently delete it?",
    "Yes": "Yes",
    "No": "No",
    athlete_team_seasons: "Seasons and teams",
    delete_sts_message: "The coach assignment to the team and season will be deleted. This action cannot be undone. Are you sure you want to permanently delete it?",
    staff_team_seasons: "Seasons and teams",
    new_video: "New video",
    "Check your credentials or ask your superior. Yo are not allowed to login now.": "Check your credentials or ask your superior. Yo are not allowed to login now.",
    "Athletes and teams": "Athletes and teams",
    "Coaches": "Coaches",
    "Edit coach": "Edita coach",
    "Delete coach": "Delete coach",
    "delete_coach_message": "Coach <strong>{{coach_name}}</strong> and all related data will be deleted. This action cannot be undone. Do you really want to delete it permanently?",
    "Competitions and events": "Competitions and events",
    "Events": "Events",
    "Passed events": "Eventos pasados",
    "New event": "New event",
    "delete_event_message": "Event <strong>{{event_name}}</strong> and all related data will be deleted. This action cannot be undone. Do you really want to delete it permanently?",
    "Athlete rankings": "Athlete rankings",
    "ranking_date": "Ranking date",
    "points_label": "Points",
    "Man": "Man",
    "Woman": "Woman",
    "delete_athlete": "Delete athlete",
    "delete_athlete_message": "Athlete <strong>{{athlete_name}}</strong> and all related data will be deleted. This action cannot be undone. Do you really want to delete it permanently?",
    "sex": "Sex",
    "select_sex": "- Select sex -",
    "Check your inbox to read the reset password instructions email.": "Check your inbox to read the reset password instructions email.",
    "Send a link to reset password": "Send a link to reset password",
    "Reset": "Reset",
    "Back to login": "Back to login",
    "Reset your password": "Reset your password",
    "Repeat password": "Repeat password",
    "Password changed. Continue to login.": "Password changed. Continue to login.",
    "The passwords entered do not match.": "The passwords entered do not match.",
    "Password must be at least 8 characters long.": "Password must be at least 8 characters long.",
    athlete_performances: "Athlete performance",
    performance_date: "Performace date",
    perf1_label: "Performance KPI 1",
    perf2_label: "Performance KPI 2",
    perf3_label: "Performance KPI 3",
    perf4_label: "Performance KPI 4",
    "New program": "New program",
    "Edit program": "Edit program",
    "Delete program": "Delete program",
    delete_program_message: "Program <strong>{{program_name}}</strong> and all related data will be deleted. This action cannot be undone. Do you really want to delete it permanently?",
    "Programs": "Programs",
    "Program members": "Program members",
    "Member since": "Member since",
    "Program documents": "Program documents",
    "Only one document can be uploaded. Delete the current document to upload a different one.": "Only one document can be uploaded. Delete the current document to upload a different one.",
    "New media": "New media",
    "Upload video, file or document": "Upload video, file or document",
    "You must upload one video, image or document": "You must upload one media",
    "Type": "Type",
    "Edit media": "Edit media",
    "Delete media": "Delete media",
    delete_program_media_message: "The media <strong>{{program_media_name}}</strong> and all data dependent on it will be deleted. This action cannot be undone. Are you sure you want to permanently delete it?",
    "Documents of": "Documents of",
    "Download": "Download",
    "This media has no coments.": "This media has no coments.",
    "Comments": "Comments",
    "Add comment": "Add comment",
    "Comment": "Comment",
    "Author": "Author",
    "Establish a link between Padeltech and your Garmin Connect account and grant the necessary permissions so we can sync information with your profile.": "Establish a link between Padeltech and your Garmin Connect account and grant the necessary permissions so we can sync information with your profile.",
    "Link with Garmin Connect": "Link with Garmin Connect",
    "Wearable is already connected. No acction needed.": "Wearable is already connected. No acction needed.",
    "There are no upcoming events.": "There are no upcoming events.",
    "Activities": "Activities",
    "Heart Rate Avg": "Heart Rate Avg",
    "Speed Avg": "Speed Avg",
    "Duration Avg": "Duration Avg",
    "Active Calories Avg": "Active Calories Avg",
    "Heart Rate": "Heart Rate",
    "Speed m/s": "Speed m/s",
    "Duration": "Duration",
    "Active Calories": "Active Calories",
    "bpm": "bpm",
    "Your reports": "Your reports",
    "All activities": "All activities",
    "January": "January",
    "February": "February",
    "March": "March",
    "April": "April",
    "May": "May",
    "June": "June",
    "July": "July",
    "August": "August",
    "September": "September",
    "October": "October",
    "November": "November",
    "December": "December",
    "Aggregated data for": "Aggregated data for",
    "This athlete has no activity data.": "This athlete has no activity data.",
    "Athlete reports": "Athlete reports",
    "Activities list": "Activities list",
    "Average": "Average",
    "Maximum": "Maximum",
    "Are you sure you want to reset? All monitoring data will be deleted and this action cannot be undone.": "Are you sure you want to reset? All monitoring data will be deleted and this action cannot be undone.",
    "Speed": "Speed",
    "Active calories": "Active calories",
    "Activity details": "Activity details",
    "Start time": "Start time",
    "This activty has no details.": "This activty has no details.",
    "Planning": "Planificación",
    "Open Weekly View": "Open Weekly View",
    "Weekly Planning": "Weekly Planning",
    "Week not found": "Week not found",
    "Monday": "Monday",
    "Tuesday": "Tuesday",
    "Wednesday": "Wednesday",
    "Thursday": "Thursday",
    "Friday": "Friday",
    "Saturday": "Saturday",
    "Sunday": "Sunday",
    "Copy Week": "Copy Week",
    "Paste Week": "Paste Week",
    "Copy Day": "Copy Day",
    "Paste Day": "Paste Day",
    "Clear Week": "Clear Week",
    "Are you sure you want to clear all data from week {{week}}? This action cannot be undone.": "Are you sure you want to clear all data from week {{week}}? This action cannot be undone.",
    "Month": "Month",
    "Week": "Week",
    "Day (Mon)": "Day (Mon)",
    "Day (Sun)": "Day (Sun)",
    "Day": "Day",
    "Training description": "Training description",
    "morning": "morning",
    "afternoon": "afternoon",
    "Team": "Team",
    "Dates": "Dates",
    "Workload": "Workload",
    "Season": "Season",
    "Data could not be saved. Try again later.": "Data could not be saved. Try again later.",
    "Are you sure you want to delete this session? This action cannot be undone.": "Are you sure you want to delete this session? This action cannot be undone.",
    "Add a new session": "Add a new session",
    "Delete this session": "Delete this session",
    "Morning session": "Morning session",
    "Afternoon session": "Afternoon session",
    "Athletes reports": "Athletes reports",
    "Training session": "Training session",
    "No data found for this training session.": "No data found for this training session.",
    "Moment": "Moment",
    "Session": "Session",
    "Session information": "Session information",
    "Training details": "Training details",
    "Totals": "Totals",
    "KM": "KM",
    "TH": "TH",
    "Levels": "Levels",
    "Periodization": "Periodization",
    "Macrocycle": "Macrocycle",
    "Period": "Period",
    "Mesocycle": "Mesocycle",
    "Main Obj.": "Main Obj.",
    "Mesoc. Obj.": "Mesoc. Obj.",
    "Microcycle": "Microcycle",
    "Define Macrocycle": "Define Macrocycle",
    "Edit Macrocycle": "Edit Macrocycle",
    "Are you sure you want to delete this macrocycle?": "Are you sure you want to delete this macrocycle?",
    "Error deleting macrocycle. Please try again.": "Error deleting macrocycle. Please try again.",
    "Define Period": "Define Period",
    "Edit Period": "Edit Period",
    "Period name": "Period name",
    "e.g., Preparation Period": "e.g., Preparation Period",
    "Please enter a name for the period": "Please enter a name for the period",
    "Error saving period. Please try again.": "Error saving period. Please try again.",
    "Are you sure you want to delete this period?": "Are you sure you want to delete this period?",
    "Error deleting period. Please try again.": "Error deleting period. Please try again.",
    "Selected weeks": "Selected weeks",
    "Macrocycle name": "Macrocycle name",
    "e.g., General Preparation": "e.g., General Preparation",
    "Background color": "Background color",
    "Please enter a name for the macrocycle": "Please enter a name for the macrocycle",
    "Define Mesocycle": "Define Mesocycle",
    "Edit Mesocycle": "Edit Mesocycle",
    "Mesocycle name": "Mesocycle name",
    "e.g., Accumulation": "e.g., Accumulation",
    "Primary Objective": "Primary Objective",
    "e.g., Build aerobic base": "e.g., Build aerobic base",
    "Mesocycle Objectives": "Mesocycle Objectives",
    "e.g., Increase volume, technique improvement": "e.g., Increase volume, technique improvement",
    "Please enter a name for the mesocycle": "Please enter a name for the mesocycle",
    "Error saving macrocycle. Please try again.": "Error saving macrocycle. Please try again.",
    "Technification": "Technification",
    "Kilometers/week water": "Kilometers/week water",
    "Hours/week ground": "Hours/week ground",
    "KM water": "KM water",
    "H ground": "H ground",
    "H Total": "H Total",
    "Level of fatigue": "Level of fatigue",
    "Results": "Results",
    "Monitoring": "Monitoring",
    "Monitoring sessions": "Monitoring sessions",
    "Training session results": "Training session results",
    "Athletes feedback": "Athletes feedback",
    "My feedback": "My feedback",
    "Enter feedback": "Enter feedback",
    "Average fatigue level": "Average fatigue level",
    "Training start": "Training start",
    "k/h": "k/h",
    "ºC": "ºC",
    "Start at": "Start at",
    "Start": "Start",
    "Pause": "Pause",
    "Resume": "Resume",
    "Finish": "Finish",
    "Stop": "Stop",
    "Register lap": "Register lap",
    "Register rest": "Register rest",
    "Last rest": "Last rest",
    "Previous rest": "Previous rest",
    "Rest": "Rest",
    "Work": "Work",
    "Lap type": "Lap type",
    "Series": "Series",
    "Recovery": "Recovery",
    "Shoverfuls": "Shoverfuls",
    "Session Summary": "Session Summary",
    "Finish time": "Finish time",
    "Time": "Time",
    "Total duration": "Total duration",
    "Total laps": "Total laps",
    "Total shovelfuls": "Total shovelfuls",
    "Laps registered": "Laps registered",
    "Laps": "Laps",
    "Lap": "Lap",
    "laps": "laps",
    "Average shovelfuls per minute per lap": "Average shovelfuls per minute per lap",
    "Shovelfuls per minute": "Shovelfuls per minute",
    "Lap times": "Lap times",
    "Lap time": "Lap time",
    "Lap details": "Lap details",
    "Elapsed": "Elapsed",
    "Delete lap": "Delete lap",
    "Are you sure you want to delete this lap? The remaining laps will be recalculated.": "Are you sure you want to delete this lap? The remaining laps will be recalculated.",
    "Error deleting lap": "Error deleting lap",
    "Edit lap": "Edit lap",
    "Edit the elapsed time from the start of the session": "Edit the elapsed time from the start of the session",
    "Minutes": "Minutes",
    "Seconds": "Seconds",
    "Milliseconds": "Milliseconds",
    "Error updating lap": "Error updating lap",
    "Monitoring history": "Monitoring history",
    "All athletes": "All athletes",
    "Sessions": "Sessions",
    "Total time": "Total time",
    "Avg. lap time": "Avg. lap time",
    "Avg. strokes/min": "Avg. strokes/min",
    "No monitoring sessions found": "No monitoring sessions found",
    "Open monitoring session": "Open monitoring session",
    "Open training session": "Open training session",
    "Add lap": "Add lap",
    "Last lap": "Last lap",
    "Previous lap": "Previous lap",
    "Diff": "Diff",
    "Minimum": "Minimum",
    "Shoverful": "Shoverful",
    "shoverful": "shoverful",
    "shoverfuls": "shoverfuls",
    "Stroke records": "Stroke records",
    "Duration (seconds)": "Duration (seconds)",
    "Planning reports": "Planning reports",
    "Avg speed": "Avg speed",
    "Max speed": "Max speed",
    "Temperature": "Temperature",
    "Wind speed": "Wind speed",
    "Wind direction": "Wind direction",
    "Observations": "Observations",
    "Monitoring training session": "Monitoring training session",
    "Switch to manual entry": "Switch to manual entry",
    "Switch to real-time mode": "Switch to real-time mode",
    "Manual session data entry": "Manual session data entry",
    "optional": "optional",
    "Save manual entry": "Save manual entry",
    "Please fill in start and end times": "Please fill in start and end times",
    "Please fill in start time and duration": "Please fill in start time and duration",
    "End time must be after start time": "End time must be after start time",
    "Session duration must be greater than 00:00:00.000": "Session duration must be greater than 00:00:00.000",
    "Invalid start time format. Use HH:MM:SS.mmm": "Invalid start time format. Use HH:MM:SS.mmm",
    "Invalid duration format. Use HH:MM:SS.mmm": "Invalid duration format. Use HH:MM:SS.mmm",
    "Total duration of the session": "Total duration of the session",
    "Calculated from lap times": "Calculated from lap times",
    "Enter duration of each lap (MM:SS.mmm)": "Enter duration of each lap (MM:SS.mmm)",
    "Use format MM:SS.mmm (duration of this lap)": "Use format MM:SS.mmm (duration of this lap)",
    "Invalid lap duration format at position": "Invalid lap duration format at position",
    "Lap duration at position": "Lap duration at position",
    "must be greater than 00:00.000": "must be greater than 00:00.000",
    "Sum of lap durations up to position": "Sum of lap durations up to position",
    "exceeds total session duration": "exceeds total session duration",
    "Sum of laps": "Sum of laps",
    "Session duration": "Session duration",
    "Enter elapsed time from start (MM:SS.mmm)": "Enter elapsed time from start (MM:SS.mmm)",
    "Elapsed time": "Elapsed time",
    "Use format MM:SS.mmm (time from session start)": "Use format MM:SS.mmm (time from session start)",
    "(time from session start) must be between 00:00.000 and session duration": "(time from session start) must be between 00:00.000 and session duration",
    "Error saving manual entry": "Error saving manual entry",
    "Add stroke record": "Add stroke record",
    "All season": "All season",
    "Fatigue level Avg": "Fatigue level Avg",
    "Temperature Avg": "Temperature Avg",
    "Wind Speed Avg": "Wind Speed Avg",
    "Fatigue level": "Fatigue level",
    "Wind Speed": "Wind Speed",
    "Athletes": "Athletes",
    "Rows per page:": "Rows per page:",
    "of": "of",
    "Category cannot be deleted. Teams of this category exist.": "Category cannot be deleted. Teams of this category exist.",
    "Icon": "Icon",
    "Speciality cannot be deleted. Modalities of this epeciality exist.": "Speciality cannot be deleted. Modalities of this epeciality exist.",
    "Modality cannot be deleted. Teams of this modality exist.": "Modality cannot be deleted. Teams of this modality exist.",
    "Delete modality": "Delete modality",
    "Season cannot be deleted. There is related data for the season.": "Season cannot be deleted. There is related data for the season.",
    "Club cannot be deleted. There is related data for the club.": "Club cannot be deleted. There is related data for the club.",
    "Team cannot be deleted. Athletes or staff are related.": "Team cannot be deleted. Athletes or staff are related.",
    "Sort by updated": "Sort by updated",
    "Sort by name": "Sort by name",
    "Ascending": "Ascending",
    "Descending": "Descending",
    "Edit": "Edit",
    "Athlete team season cannot be deleted. There is data related.": "Athlete team season cannot be deleted. There is data related.",
    "Athlete cannot be deleted. There is season data related.": "Athlete cannot be deleted. There is season data related.",
    "Staff cannot be deleted. There is season data related.": "Staff cannot be deleted. There is season data related.",
    "Competition cannot be deleted. Try again later.": "Competition cannot be deleted. Try again later.",
    "Event cannot be deleted. Try again later.": "Event cannot be deleted. Try again later.",
    "Measurement cannot be deleted. Try again later.": "Measurement cannot be deleted. Try again later.",
    "Load more": "Load more",
    "Measurements": "Measurements",
    "N. Sess.": "N. Sess.",
    "C.D.": "C.D.",
    "Sections Index": "Sections Index",
    "Back to top": "Back to top",
    "Error loading planning reports. Please try again.": "Error loading planning reports. Please try again.",
    "Error loading season options. Please refresh the page.": "Error loading season options. Please refresh the page.",
    "Error loading athlete activities. Please try again.": "Error loading athlete activities. Please try again.",
    "Error loading athletes. Please refresh the page.": "Error loading athletes. Please refresh the page.",
    "Select participating athletes": "Select participating athletes",
    "Search athletes by name...": "Search athletes by name...",
    "No athletes found": "No athletes found",
    "Session notes (optional)": "Session notes (optional)",
    "No athletes available for this team": "No athletes available for this team",
    "athlete count singular": "athlete",
    "athlete count plural": "athletes",
    "athlete selected": "athlete selected",
    "athletes selected": "athletes selected",
    "Start monitoring": "Start monitoring",
    "Please select at least one athlete": "Please select at least one athlete",
    "Error starting monitoring session": "Error starting monitoring session",
    "Participating athletes": "Participating athletes",
    "This monitoring will be performed for all team athletes": "This monitoring will be performed for all team athletes",
    "Select session athletes": "Select session athletes",
    "Coach comments": "Coach comments",
    "No comments added yet": "No comments added yet",
    "Edit comments": "Edit comments",
    "Add comments": "Add comments",
    "Add your comments about this training session...": "Add your comments about this training session...",
    "Error saving comments": "Error saving comments",
    "Number of strokes per minute": "Number of strokes per minute",
    "Strokes per minute": "Strokes per minute",
    "Accumulated": "Accumulated",
    "A new version is available. Please reload the page to get the latest updates.": "A new version is available. Please reload the page to get the latest updates.",
    "Reload": "Reload",
    "Lap time at position": "Lap time at position",
    "must be between start and end time": "must be between start and end time",
    "Range": "Range",
    "Lap times must be in chronological order. Error at position": "Lap times must be in chronological order. Error at position",
    "Invalid stroke time format at position": "Invalid stroke time format at position",
    "Use format HH:MM:SS": "Use format HH:MM:SS",
    "Stroke time at position": "Stroke time at position",
    "Existing monitoring sessions": "Existing monitoring sessions",
    "There are monitoring sessions for this training session. You can continue with an existing one or create a new one.": "There are monitoring sessions for this training session. You can continue with an existing one or create a new one.",
    "Create new monitoring session": "Create new monitoring session",
    "Error loading monitoring session": "Error loading monitoring session",
    "Back to monitoring list": "Back to monitoring list",
    "events": "events",
    "View": "View",
    "Are you sure you want to delete this monitoring session? This action cannot be undone.": "Are you sure you want to delete this monitoring session? This action cannot be undone.",
    "Error deleting monitoring session": "Error deleting monitoring session",

    // Document Management
    "Document Management": "Document Management",
    "My Documents": "My Documents",
    "New Folder": "New Folder",
    "Upload Document": "Upload Document",
    "Folder Name": "Folder Name",
    "Enter folder name": "Enter folder name",
    "Enter folder description": "Enter folder description",
    "Description": "Description",
    "Edit Folder": "Edit Folder",
    "Folder name is required": "Folder name is required",
    "Error saving folder": "Error saving folder",
    "Enter a description for this document": "Enter a description for this document",
    "Please select a file": "Please select a file",
    "Error uploading document": "Error uploading document",
    "Uploading files...": "Uploading files...",
    "Drop files here to upload": "Drop files here to upload",
    "Some files failed to upload": "Some files failed to upload",
    "Error uploading files": "Error uploading files",
    "Uploading...": "Uploading...",
    "selected": "selected",
    "Clear selection": "Clear selection",
    "Delete selected": "Delete selected",
    "Are you sure you want to delete the selected items?": "Are you sure you want to delete the selected items?",
    "Error deleting items": "Error deleting items",
    "Error moving items": "Error moving items",
    "Some items failed to delete": "Some items failed to delete",
    "Download selected": "Download selected",
    "Error downloading items": "Error downloading items",
    "Error downloading folder": "Error downloading folder",
    "Edit Document": "Edit Document",
    "Document Name": "Document Name",
    "Enter document name": "Enter document name",
    "Document name is required": "Document name is required",
    "Error saving document": "Error saving document",
    "Enter document description": "Enter document description",
    "Folder": "Folder",
    "Document": "Document",
    "Share": "Share",
    "Add New Share": "Add New Share",
    "Share Type": "Share Type",
    "Specific User": "Specific User",
    "Entire Club": "Entire Club",
    "Entire Team": "Entire Team",
    "Club Role": "Club Role",
    "Team Role": "Team Role",
    "Select User": "Select User",
    "Select a user...": "Select a user...",
    "Select Club": "Select Club",
    "Select a club...": "Select a club...",
    "Select Team": "Select Team",
    "Select a team...": "Select a team...",
    "Select Role": "Select Role",
    "Select a role...": "Select a role...",
    "Please select a target": "Please select a target",
    "Please select a role": "Please select a role",
    "Error sharing item": "Error sharing item",
    "Share added successfully": "Share added successfully",
    "Share removed successfully": "Share removed successfully",
    "Adding...": "Adding...",
    "Add": "Add",
    "Add Share": "Add Share",
    "Current Shares": "Current Shares",
    "Are you sure you want to remove this share?": "Are you sure you want to remove this share?",
    "Error removing share": "Error removing share",
    "Not shared with anyone yet": "Not shared with anyone yet",
    "Shared": "Shared",
    "Share with": "Share with",
    "All clubs": "All clubs",
    "All teams": "All teams",
    "All tags": "All tags",
    "Tags": "Tags",
    "Select tag": "Select tag",
    "New tag": "New tag",
    "Search tags": "Search tags",
    "No tags found": "No tags found",
    "Filter by tags": "Filter by tags",
    "Could not create tag. It may already exist.": "Could not create tag. It may already exist.",
    "Error creating tag. Please try again.": "Error creating tag. Please try again.",
    "Could not rename tag. The name may already exist.": "Could not rename tag. The name may already exist.",
    "Error updating tag. Please try again.": "Error updating tag. Please try again.",
    "Error deleting tag. Please try again.": "Error deleting tag. Please try again.",
    "Are you sure you want to delete the tag \"{{name}}\"?": "Are you sure you want to delete the tag \"{{name}}\"?",
    "Filter by club": "Filter by club",
    "Filter by team": "Filter by team",
    "Select clubs to share with": "Select clubs to share with",
    "Select teams to share with": "Select teams to share with",
    "Select coaches to share with": "Select coaches to share with",
    "Select athletes to share with": "Select athletes to share with",
    "Please select at least one club": "Please select at least one club",
    "Please select at least one team": "Please select at least one team",
    "Please select at least one coach": "Please select at least one coach",
    "This folder is empty": "This folder is empty",
    "Are you sure you want to delete this folder?": "Are you sure you want to delete this folder?",
    "Error deleting folder": "Error deleting folder",
    "Are you sure you want to delete this document?": "Are you sure you want to delete this document?",
    "Error deleting document": "Error deleting document",
    "Error downloading document": "Error downloading document",
    "List view coming soon...": "List view coming soon...",
    "You must belong to a club to share resources": "You must belong to a club to share resources",
    "Managers can only share with coaches and athletes": "Managers can only share with coaches and athletes",
    "You can only share with users from your clubs": "You can only share with users from your clubs",
    "You can only share with your own clubs": "You can only share with your own clubs",
    "You can only share with teams from your clubs": "You can only share with teams from your clubs",
    "You can only share with users from your club": "You can only share with users from your club",
    "You can only share with your own club": "You can only share with your own club",
    "You can only share with teams from your club": "You can only share with teams from your club",
    "As a manager, you can only share with coaches and athletes from your clubs.": "As a manager, you can only share with coaches and athletes from your clubs.",
    "As a coach, you can only share with users from your club.": "As a coach, you can only share with users from your club.",
    "As an athlete, you cannot share documents. You can only view documents shared with you.": "As an athlete, you cannot share documents. You can only view documents shared with you.",
    "You cannot move items to a shared folder": "You cannot move items to a shared folder",
    "Folders": "Folders",
    "Shared with me": "Shared with me",
    "Shared by": "Shared by",
    "Search...": "Search...",
    "items": "items",
    "Date": "Date",
    "Size": "Size",
    "Newest": "Newest",
    "Oldest": "Oldest",
    "Largest": "Largest",
    "Smallest": "Smallest",
    "No results found": "No results found",
    "Rename": "Rename",
    "Export PDF": "Export PDF",
    "Generating...": "Generating...",
    "Error generating PDF. Try again later.": "Error generating PDF. Try again later.",
    "No training data available for this week. Cannot generate PDF.": "No training data available for this week. Cannot generate PDF.",
    "Export Annual PDF": "Export Annual PDF",
    "Please select a season and team first.": "Please select a season and team first.",
    "No planning data available. Please load planning data first.": "No planning data available. Please load planning data first.",
    "Viewing documents of": "Viewing documents of",
    "Back to my documents": "Back to my documents",
    "Search user by name, team or club...": "Search user by name, team or club...",
    "Search user by name, email, team, club or role...": "Search user by name, email, team, club or role...",
    "Search athlete by name, team or club...": "Search athlete by name, team or club...",
    "Change athlete": "Change athlete",
    "No Garmin": "No Garmin",
    profile_avatar_upload_message: "Optionally upload profile photo"
};